import React, {useState, useRef, useEffect} from 'react';
import {LazyImage, OnlineAddress, OnlineMedAddress} from "../../../Components";
import {detectEnglishLang, numberWithCommas} from "../../../Services";
import uploadLogo from "../../../assets/images/upload_icon.svg";
import {DeleteOutlined} from '@ant-design/icons';
import {message, Popconfirm,Modal,Spin,Collapse} from 'antd';
import moment from "moment-jalaali";
import {
    createmedOrder_api,
    finialMedOrder_api,
    getAddressList_api,
    getMallMerchant_api,
    getMeds_api
} from "../../../Services/apis";
import {StoreOnlineCreateInvoice} from "../../Payment/PaymentService";
import { Pagination } from 'antd';
import {useHistory} from "react-router";

let page = 1

const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

const convertStatusCode = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result  =  "اولیه"
            break;
        case 2:
            result  =  "آماده پرداخت"
            break;
        case 3:
            result  =  "پرداخت شده"
            break;
        case 5:
            result  =  "رد شده توسط صندوقدار"
            break;
        case 9:
            result  =  "شروع جمع آوری"
            break;
        case 10:
            result  =  "جمع آوری شده"
            break;
        case 13:
            result  =  "آماده ارسال"
            break;
        case 14:
            result  =  "در حال پیدا کردن پیک"
            break;
        case 15:
            result  =  "قبول شده توسط پیک"
            break;
        case 20:
            result  =  "در حال ارسال"
            break;
        case 25:
            result  =  "تحویل شده"
            break;
        case 30:
            result  =  "توسط مشتری کنسل شد"
            break;
        case 31:
            result  =  "توسط داروخانه کنسل شد"
            break;
        case 32:
            result  =  "توسط میاره کنسل شد"
            break;
    }

    return result;

}



const OTC_card = ({e,change}) => {



    return (
        <div className="med-detail-modal-item">
            <div className="med-detail-modal-item-info">
                <span>{e.name}</span>
            </div>
            <div className="med-detail-modal-item-form">
                <div className="med-detail-modal-item-form-price">
                    <span>  {numberWithCommas(e.discount)} تخفیف (ریال)  </span>
                    <span>  {numberWithCommas(e.price)} قیمت (ریال) </span>
                </div>

                <div className="med-detail-modal-item-form-desc">
                               <p>{e.description}</p>
                </div>
            </div>
        </div>
    )
}


const FP_card = ({e,change}) => {



    return (
        <div className="med-detail-modal-item">
            <div className="med-detail-modal-item-info">
                <img src={e.file} alt=""/>
            </div>
            <div className="med-detail-modal-item-form">
                <div className="med-detail-modal-item-form-price">
                    <span>  {numberWithCommas(e.discount)} تخفیف (ریال)  </span>
                    <span>  {numberWithCommas(e.price)} قیمت (ریال) </span>
                </div>

                <div className="med-detail-modal-item-form-desc">
                    {e.description}
                </div>
            </div>
        </div>
    )
}


// e_prescription
// files
// otc


const EP_card = ({e}) => {

    return (
        <div className="med-detail-modal-item">
            <div className="med-detail-modal-item-info">
                <span>{`کد ملی : ${e.national_code}/کد رهگیری :${e.prescription_id}/نام پزشک :${e.dr_name}`}</span>
            </div>
            <div className="med-detail-modal-item-form">
                <div className="med-detail-modal-item-form-price">
                    <span>  {numberWithCommas(e.discount)} تخفیف (ریال)  </span>
                    <span>  {numberWithCommas(e.price)} قیمت (ریال) </span>
                </div>

                <div className="med-detail-modal-item-form-desc">
                                <p>{e.description}</p>
                </div>
            </div>
        </div>
    )
}


function makeid(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}


const MedC = ({med}) => {

    const items = []


    return (
        <div className="med-detail-modal-body-desc">


            {med.e_prescription.map(e => {
                return (
                    <EP_card e={e} />
                )
            })}

            {med.files.map(e => {
                return (
                    <FP_card e={e} />
                )
            })}


            {med.otc.map(e => {
                return (
                    <OTC_card e={e} />
                )
            })}

        </div>
    )
}


const convertTicketStatus = (status)=>{
    switch(status){
        case 1:
            return "در حال بررسی"
            break;
        case 2:
            return "تایید شده"
            break;
        case 3:
            // return "تایید شده توسط مشتری"
            return "منتظر پرداخت"
            break;
        case 4:
            return "پرداخت شده"
            break;
        case 5:
            return "رد شده"
            break;
    }
}


const convertOrderStatusColor = (status)=>{
    switch(status){
        case 1:
            return "#f5d250"
            break;
        case 2:
            return "#40a9ff"
            break;
        case 3:
            return "#b9e872"
            break;
        case 4:
            return "#70bf4e"
            break;
        case 5:
            return "#ea6c6c"
            break;
    }
}


const convertTicketStatusColor = (status)=>{
    switch(status){
        case 1:
            return "#f5d250"
            break;
        case 2:
            return "#40a9ff"
            break;
        case 3:
            return "#39e4f3"
            break;
        case 4:
            return "#70bf4e"
            break;
        case 5:
            return "#ea6c6c"
            break;
    }
}



function MedCard({p,generateDescFromPrescription,del,mId}) {


    const [currentDetail, set_currentDetail] = useState({});
    const [spin, set_spin] = useState(false);
    const [isCouponModalVisible, setIsCouponModalVisible] = useState(false);

    const history = useHistory()

    const showModal = () => {
        setIsCouponModalVisible(true);
    };

    const handleOk = () => {
        setIsCouponModalVisible(false);
    };

    const handleCancel = () => {
        setIsCouponModalVisible(false);
    };


    const finalizedMed = async (p)=> {

        //set address
        try{
            const res = await finialMedOrder_api(p.uid)

            let f = res.data.invoice;

            try {
                //create invoice
                let req = {
                    amount: f.payable_amount,
                    client_callback: window.location.origin+"/dr-shop/bank-result/"+f.uid,
                    res_num: f.uid,
                    merchant_uid: f.merchant.uid
                }
                const response = await StoreOnlineCreateInvoice(req);
                history.push(`/dr-shop/pay/${f.merchant.uid}`, {create: response.data,finalObj:{invoice:f}})
                // history.push(`/dr-shop/preinvoice/${f.merchant.uid}`, {create: response.data})
            } catch (e) {
                // console.log(e)
                return
            }

        }catch (e) {

            console.log(e)
        }

    }

    // const directPay = async (f)=>{
    //     console.log("f",f)
    //
    //     try {
    //         //create invoice
    //         let req = {
    //             amount: f.payable_amount,
    //             client_callback: window.location.origin+"/dr-shop/bank-result/"+f.uid,
    //             res_num: f.uid,
    //             merchant_uid: f.merchant.uid
    //         }
    //         const response = await StoreOnlineCreateInvoice(req);
    //         history.push(`/dr-shop/pay/${f.merchant.uid}`, {create: response.data,finalObj:{invoice:f}})
    //         // history.push(`/dr-shop/preinvoice/${f.merchant.uid}`, {create: response.data})
    //     } catch (e) {
    //         // console.log(e)
    //         return
    //     }
    // }



    return(
        <div className="prescription-body-pItem">


            <Modal visible={isCouponModalVisible}  footer={null}   onOk={handleOk} onCancel={handleCancel}>


                <Spin spinning={spin}>
                    <div className="request-detail-modal">
                        <div className="request-detail-modal-header">
                            <div className="request-detail-modal-header-title" >
                                <span>آدرس خود را انتخاب نمایید : </span>
                            </div>
                            {mId?<OnlineMedAddress merchantId={mId} medId={p.uid}/>:null}
                        </div>
                        <div className="request-detail-modal-body">
                            <MedC med={p}/>
                        </div>

                        <div className="med-detail-modal-footer">


                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.total_discount)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">تخفیف </span>
                            </div>

                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.tech_cost)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">حق فنی </span>
                            </div>


                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.total_amount)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">مبلغ قابل پرداخت</span>
                            </div>

                        </div>



                        <div className="med-detail-modal-footer-btns">
                            <div className="med-detail-modal-footer-btn-accept" onClick={e=>{
                                finalizedMed(p)
                            }}>
                                <span>مشاهده فاکتور</span>
                            </div>
                            {/*<div className="med-detail-modal-footer-btn-reject" onClick={e=>{*/}
                            {/*    // rejectMedOrder()*/}
                            {/*}}>*/}
                            {/*    <span>رد کردن</span>*/}
                            {/*</div>*/}
                        </div>

                    </div>
                </Spin>


            </Modal>

            <div className="prescription-body-pItem-info">
                <div className="prescription-body-pItem-title">
                    <span>{moment(
                        p.created
                    ).format(
                        "HH:mm - jYYYY/jMM/jDD"
                    )}</span>

                </div>
                <div className="med-body-pItem-description">
                    {p.e_prescription.map(e=>{
                        return(
                            <span>{`کد ملی : ${e.national_code}/کد رهگیری :${e.prescription_id}/نام پزشک :${e.dr_name}`}</span>
                        )
                    })}

                    {p.files.map(e=>{
                        return(
                            <img src={e.file} alt=""/>
                        )
                    })}


                    {p.otc.map(e=>{
                        return(
                            <span>{e.name}</span>
                        )
                    })}


                    {/*{p.e_prescription?<span>{p.e_prescription}</span>:null}*/}
                    {/*{p.otc_prescription?<span>{p.otc_prescription}</span>:null}*/}
                    {/*{p.image_prescription?<img src={p.image_prescription} alt=""/>:null}*/}
                </div>
            </div>


            {p.order_status && p.order_status[0] && p.order_status[0]>2?
                <div className="med-body-pItem-status" style={{backgroundColor:convertOrderStatusColor(p.order_status[0])}}>
                        <span>{convertStatusCode(p.order_status[0])}</span>
                </div>:<div className="med-body-pItem-status" style={{backgroundColor:convertTicketStatusColor(p.status)}}>
                        <span>{convertTicketStatus(p.status)}</span>
                </div>}




            {p.order_status && p.order_status[0] && p.order_status[0]>2?
                <div></div>
            :
                <div>
                    {p.status===2 || p.status===3?<div className="med-pay-btn" onClick={e=>{
                        showModal(p)
                    }} >
                        <span> پرداخت  {numberWithCommas(p.total_amount)} ریال </span>
                    </div>:null}
                </div>
            }




        </div>
    )
}



function OrderCard({p,generateDescFromPrescription,del}) {

    const confirm = (e) => {
        console.log(e);
        del(p.id)
        // message.success('Click on Yes');
    };
    const cancel = (e) => {
        console.log(e);
        // message.error('Click on No');
    };


    return(
        <div className="prescription-body-pItem">

            <div className="prescription-body-pItem-info">
                <div className="prescription-body-pItem-title">
                    <span>{p.title}</span>
                </div>
                <div className="prescription-body-pItem-description">
                    {p.type==="otc" || p.type==="electronic"?
                        <span>{generateDescFromPrescription(p)}</span>:null
                    }
                    {p.type==="pic" ?
                        <ImagePrev  file={p.imageData}/>
                        :null
                    }
                </div>
            </div>

            <div className="prescription-body-pItem-edit">
                <Popconfirm
                    title="آیا شما از حذف مطمئن هستید ؟"
                    onConfirm={confirm}
                    onCancel={cancel}
                    okText="بله"
                    cancelText="خیر"
                >
                    <DeleteOutlined/>
                </Popconfirm>
            </div>
        </div>
    )

}

const ImagePrev = ({file})=>{

    const [prev,set_prev] = useState()


    return(
        <img style={{width:200}} src={file} alt=""/>
    )
}

function PrescriptionSec({item, LinkDispatcher}) {


    const fileRef = useRef()

    //meds
    const [meds,set_meds] = useState([])

    //orders
    const [prescriptions, set_prescriptions] = useState([])
    const [currentPrescription, set_currentPrescription] = useState([])
    const [activeTab, set_activeTab] = useState("default") // default | e-prescription | pic-prescription | otc

    //e-prescription
    const [insuranceType, set_insuranceType] = useState("tamin") // tamin | salamat
    const [national_code, set_national_code] = useState("")
    const [doctor_name, set_doctor_name] = useState("")
    const [tracking_code, set_tracking_code] = useState("")


    const [drug_name, set_drug_name] = useState("")
    const [drug_type, set_drug_type] = useState("")
    const [drug_dose, set_drug_dose] = useState("")
    const [drug_count, set_drug_count] = useState("")
    const [drug_unit, set_drug_unit] = useState("")


    let prescriptionObj = {
        items: [
            {
                type: "otc", // otc | pic | electronic
                title: "",
                description: "",
                image: "",
                insuranceType: "",
                doctor_name: "",
                national_code: "",
                tracking_code: ""
            }
        ]
    }

    const addToCurrentPrescription = () => {
        switch (activeTab) {
            case "e-prescription":
                addEPrescription()
                break;
            case "pic-prescription":
                addPicPrescription()
                break;
            case "otc":
                addOtcPrescription()
                break;
        }
    }




    const resetPrescription = () => {
        set_insuranceType("tamin")
        set_national_code("")
        set_doctor_name("")
        set_tracking_code("")

        set_drug_name("")
        set_drug_count("")
        set_drug_unit("")
        set_drug_dose("")
        set_drug_type("")
        setDataFile("")

        setSelectedFile(null)
        setPreview(null)
    }

    const addPicPrescription = () => {
        // const exist = prescriptions.find(p => p.type === "pic")
        // if (exist)
        //     return message.error('این نوع نسخه اضافه شده است');

        if (!preview)
            return message.error('لطفا تصویر نسخه را بارگذاری نمایید');


        let obj = {
            type: "pic", // otc | pic | electronic
            title: "تصویر نسخه",
            id:makeid(7),
            description: "",
            imageData:dataFile,
            image: selectedFile
        }

        try{
            set_prescriptions([...prescriptions, obj])
            let str = JSON.stringify([...prescriptions, obj])
            localStorage.setItem('prescriptions',str )
        }catch (e) {
            console.log(e)
        }

        resetPrescription()
        return message.success('نسخه به سفارش شما اضافه شد');


    }

    const addOtcPrescription = () => {

        //validation

        // const exist = prescriptions.find(p => p.type === "otc")
        // if (exist)
        //     return message.error('این نوع نسخه اضافه شده است');

        if (drug_name.length < 1)
            return message.error('لطفا نام دارو را کامل نمایید');

        // if (drug_dose.length < 1)
        //     return message.error('لطفا دوز را کامل نمایید');

        if (drug_count.length < 1)
            return message.error('لطفا تعداد را کامل نمایید');


        let obj = {
            type: "otc", // otc | pic | electronic
            title: "بدون نسخه",
            description: "",
            image: "",
            id:makeid(7),
            drug_name: drug_name,
            drug_count: drug_count,
            drug_unit: drug_unit,
            drug_type: drug_type,
            drug_dose: drug_dose
        }


        set_prescriptions([...prescriptions, obj])
        localStorage.setItem('prescriptions', JSON.stringify([...prescriptions, obj]))
        resetPrescription()
        return message.success('نسخه به سفارش شما اضافه شد');



    }

    const addEPrescription = () => {

        //validation

        // const exist = prescriptions.find(p => p.type === "electronic")
        // if (exist)
        //     return message.error('این نوع نسخه اضافه شده است');

        if (national_code.length < 1)
            return message.error('لطفا کدملی را کامل نمایید');

        if (doctor_name.length < 1)
            return message.error('لطفا نام پزشک را کامل نمایید');

        if (insuranceType === "salamat" && tracking_code.length < 1)
            return message.error('لطفا کد رهگیری را کامل نمایید ');

        let obj = {
            type: "electronic", // otc | pic | electronic
            title: "نسخه الکترونیک",
            description: "",
            id:makeid(7),
            image: "",
            insuranceType: insuranceType,
            doctor_name: doctor_name,
            national_code: national_code,
            tracking_code: tracking_code
        }
        set_prescriptions([...prescriptions, obj])
        localStorage.setItem('prescriptions', JSON.stringify([...prescriptions, obj]))
        resetPrescription()
        return message.success('نسخه به سفارش شما اضافه شد');
    }




    const changeTab = (name) => {
        set_activeTab(name)
    }

    const [selectedFile, setSelectedFile] = useState()
    const [dataFile, setDataFile] = useState("")
    const [preview, setPreview] = useState()


    // create a preview as a side effect, whenever selected file is changed
    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined)
            return
        }

        dataUrl(selectedFile)
        const objectUrl = URL.createObjectURL(selectedFile)
        setPreview(objectUrl)

        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])


    const dataUrl = async (f)=>{
        let data = await toBase64(f)
        setDataFile(data)
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    useEffect(()=>{
        let localP = localStorage.getItem('prescriptions')
        if(localP) {
            set_prescriptions(JSON.parse(localP))
        }
    },[])


    useEffect(()=>{
        getMeds()
        getMerchant()
    },[])

    const [merchant,set_merchant] = useState(null)

    const getMerchant = async ()=>{
        try{
            const mer = await getMallMerchant_api()
            set_merchant(mer.data)
        }catch (e) {
            console.log(e)
        }
    }

    const getMeds =  async ()=>{
        try{
            const res= await getMeds_api(page);
            set_meds(res.data.results)
            set_total(res.data.count)
        }catch (e) {
            console.log(e)
        }
    }

    const handleFileChange = (e) => {

        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFile(undefined)
            return
        }

        // I've kept this example simple by using the first image instead of multiple
        setSelectedFile(e.target.files[0])

    }

    const handleClickOnFile = () => {
        fileRef.current.click();
    }


    const generateDescFromPrescription = (p) => {
        switch (p.type) {
            case "otc":
                return generateOtcDescription(p)
                break;
            case "electronic":
                return generateElectronicDescription(p)
                break;
            default:
                return ""
        }
    }

    const deletePrescriptionFromOrder = (id)=>{
        let filtered = prescriptions.filter(p=>p.id!==id)
        set_prescriptions(filtered)
        console.log("filtered",filtered)
        localStorage.setItem("prescriptions",JSON.stringify(filtered))
    }



    const generateElectronicDescription = (p)=>{
        console.log("",p.insuranceType)
        if(p.insuranceType==="tamin"){
            p['insuranceType']= "تامین اجتماعی"
        }

        if(p.insuranceType==="salamat"){
            p['insuranceType']= "سلامت"
        }

        return "نام پزشک :"+p.doctor_name+"/"+"کد ملی : "+p.national_code+"/"+"کد رهگیری  : "+p.tracking_code+"/"+"نوع بیمه :"+p.insuranceType
    }

    const generateOtcDescription = (p)=>{
        return "نام دارو :"+p.drug_name+"/"+"تعداد دارو :"+p.drug_count+"/"+"واحد دارو :"+p.drug_unit+"/"+"نوع دارو :"+p.drug_type+"/"+"دوز دارو :"+p.drug_dose
    }


    function dataURLtoBlob(dataURL) {
        let byteString = atob(dataURL.split(',')[1]);
        let mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    }

    const finalizeAddOrder = async ()=>{
        try{
            const mer = await getMallMerchant_api()


            // let obj = {
            //     otc_prescription:"",
            //     file:"",
            //     e_prescription:""
            // }
            //
            // let otc = prescriptions.find(p=>p.type==="otc")
            // let pic = prescriptions.find(p=>p.type==="pic")
            // let electronic = prescriptions.find(p=>p.type==="electronic")
            //
            //
            //
            //
            //
            // if(otc)
            //     obj['otc_prescription'] = generateOtcDescription(otc)
            //
            // if(electronic)
            //     obj['e_prescription'] = generateElectronicDescription(electronic)
            //
            // if(pic)
            //     obj['file'] = pic.image
            //
            //



            let obj_p = {
                merchant_uid:mer.data.uid,
                otc:prescriptions.filter(f=>f.type==="otc").map(p=> {
                    return {name: generateOtcDescription(p)}
                }),

                files:prescriptions.filter(f=>f.type==="pic").map(p=> {
                    return {file:p.imageData}
                }),

                e_prescription:prescriptions.filter(f=>f.type==="electronic").map(p=> {
                    return {national_code: p.national_code, dr_name: p.doctor_name, prescription_id: p.tracking_code}
                })

            }

            console.log("vvvvvvvvvvvv :",obj_p)

            if(obj_p.files.length<1)
                delete obj_p.files

            if(obj_p.e_prescription.length<1)
                delete obj_p.e_prescription

            if(obj_p.otc.length<1)
                delete obj_p.otc


            await createmedOrder_api(obj_p)
            set_prescriptions([])
            localStorage.removeItem("prescriptions")
            return message.success('سفارش شما با موفقیت ارسال شد');
        }catch (e) {
            console.log(e)
            return message.error('مشکل در ارسال سفارش');
        }

    }


    const [total,set_total] = useState(0)

    const handleOnchangePage = (p,size)=>{
        console.log(p,size)
        page = p;
        getMeds()
    }

    const onChange = (key) => {
        console.log(key);
    };


    return (
        <div style={{margin: "20px 16px 0 16px"}}>


            <div className="prescription-container">
                <input
                    style={{display: "none"}}
                    ref={fileRef}
                    type="file" name="" id="" onChange={handleFileChange}/>


                {/*Header*/}
                <div className="prescription-header">


                    <div className="prescription-header-address">
                        {/*<span className="prescription-header-address-label">آدرس  :</span>*/}
                        {/*<span className="prescription-header-address-path">تهران - طرشت - خ قاسمی - خ صادقی</span>*/}
                    </div>

                    <div className="prescription-header-visit-order-btn" onClick={e => {
                        getMeds()
                        set_activeTab("track")
                        console.log(prescriptions)
                    }}>
                        <span>پیگیری سفارشات </span>
                        {/*<div className="prescription-header-tracking-badge">*/}
                        {/*    <span>3</span>*/}
                        {/*</div>*/}
                    </div>

                    {/*<div className="prescription-header-title">*/}
                    {/*    <span>داروی خود را سفارش دهید</span>*/}
                    {/*</div>*/}

                </div>


                {/*Tabs*/}
                <div className="prescription-tabs">


                    <div className={activeTab === "list" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                         onClick={e => changeTab("list")}>
                        {prescriptions.length>0?
                            <span className="med-basket-badge">{prescriptions.length}</span>:
                            null
                        }

                        <span>سبد سفارش نسخه</span>
                    </div>

                    <div className={activeTab === "otc" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                         onClick={e => changeTab("otc")}>
                        <span>داروهای بدون نسخه</span>
                    </div>

                    <div
                        className={activeTab === "pic-prescription" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                        onClick={e => changeTab("pic-prescription")}>
                        <span>عکس نسخه</span>
                    </div>

                    <div
                        className={activeTab === "e-prescription" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                        onClick={e => changeTab("e-prescription")}>
                        <span>نسخه الکترونیک</span>
                    </div>

                </div>


                {/*Body*/}
                <div className="prescription-body">

                    {activeTab === "default" ?
                        <div className="prescription-body-default">
                            <div className="prescription-body-default-title">
                                <span>راهنمای ثبت سفارش </span>
                            </div>

                            <div className="prescription-body-default-row">
                                <span> جستجو و ارسال سفارش شما ممکن است بیش از سه ساعت زمان ببرد، این سرویس برای سفارش در شرایط اورژانسی نیست.</span>
                            </div>

                            <div className="prescription-body-default-row">
                                <span>سرویس تهیه دارو در شهرهای تهران، مشهد، اصفهان، تبریز، کرج، رشت، ارومیه، اهواز، شیراز، قم  در دسترس است. </span>
                            </div>

                            <div className="prescription-body-default-row">
                                <span>پس از تایید نسخه و‌ یا اقلام دارویی شما توسط داروخانه ، براساس قوانین و‌ مقررات فنی داروخانه‌ها، هزینه نسخه برای شما پیامک می‌شود.</span>
                            </div>

                            <div className="prescription-body-default-row">
                                <span>ممکن است اصل نسخه فیزیکی توسط داروخانه درخواست شود. در این صورت پیک ابتدا نسخه شما را دریافت و پس از ارائه به داروخانه، داروی شما تحویل می‌گردد.</span>
                            </div>

                        </div>
                        : null}

                    {activeTab === "otc" ?
                        <div className="prescription-body-otc-prescription">

                            {/*<div className="prescription-body-otc-prescription-upload">*/}
                            {/*    <img src={uploadLogo} alt=""/>*/}
                            {/*    <span>آپلود تصو یبلیبلر دارو</span>*/}
                            {/*</div>*/}

                            <div className="prescription-body-otc-prescription-form">

                                <div className="prescription-body-otc-prescription-form-row">
                                    <div className="prescription-body-otc-prescription-form-item">
                                        <input
                                            value={drug_name}
                                            onChange={e => {
                                                set_drug_name(e.target.value);
                                            }}
                                            type="text" placeholder="نام دارو"/>
                                    </div>
                                    <div className="prescription-body-otc-prescription-form-item">
                                        <select
                                            value={drug_type}
                                            onChange={e => {
                                                set_drug_type(e.target.value);
                                            }}
                                            name="" id="" placeholder="نوع دارو">
                                            <option value="قرص">قرص</option>
                                            <option value="شربت">شربت</option>
                                            <option value="کرم">کرم</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="prescription-body-otc-prescription-form-row">
                                    <div className="prescription-body-otc-prescription-form-item">
                                        <input
                                            value={drug_dose}
                                            onChange={e => {
                                                set_drug_dose(e.target.value);
                                            }}
                                            type="text" placeholder="دوز دارو"/>
                                    </div>
                                    <div className="prescription-body-otc-prescription-form-item">
                                        <input
                                            value={drug_count}
                                            onChange={e => {
                                                set_drug_count(e.target.value);
                                            }}
                                            type="text" placeholder="تعداد"/>
                                    </div>
                                    <div className="prescription-body-otc-prescription-form-item">
                                        <select
                                            value={drug_unit}
                                            onChange={e => {
                                                set_drug_unit(e.target.value);
                                            }}
                                            name="" id="" placeholder="انتخاب واحد">
                                            <option value="ورق">ورق</option>
                                            <option value="بسته">بسته</option>
                                            <option value="بطری">بطری</option>
                                        </select>
                                    </div>
                                </div>

                            </div>


                        </div>
                        : null}


                    {activeTab === "pic-prescription" ?
                        <div className="prescription-body-pic-prescription">


                            <div className="prescription-body-pic-prescription-upload" onClick={e => {
                                handleClickOnFile()
                            }}>
                                {!selectedFile && <img src={uploadLogo} alt=""/>}
                                {selectedFile && <img src={preview}/>}
                                <span>آپلود تصویر</span>

                            </div>


                            <div className="prescription-body-pic-prescription-info">
                                <span>عکس نسخه</span>
                                <p>توضیحات : دقت کنید عکس نسخه واضح و از بالا گرفته شود .</p>
                                <p>( حجم تصویر کمتر از ۱ مگا بایت باشد )</p>
                            </div>
                        </div>
                        : null}

                    {activeTab === "e-prescription" ?
                        <div className="prescription-body-e-prescription">
                            <div className="prescription-body-e-prescription-form">
                                <div className="prescription-body-e-prescription-form-item">
                                    <input
                                        value={national_code}
                                        onChange={e => set_national_code(e.target.value)}
                                        type="text" name="" id="" placeholder="کد ملی"/>
                                </div>
                                <div className="prescription-body-e-prescription-form-item">
                                    <input
                                        value={doctor_name}
                                        onChange={e => set_doctor_name(e.target.value)}
                                        type="text" name="" id="" placeholder="نام پزشک"/>
                                </div>
                                {insuranceType === "salamat" ?
                                    <div className="prescription-body-e-prescription-form-item">
                                        <input
                                            value={tracking_code}
                                            onChange={e => set_tracking_code(e.target.value)}
                                            type="text" name="" id="" placeholder="کد رهگیری"/>
                                    </div> : null}
                            </div>

                            <div className="prescription-body-e-prescription-choose">
                                <div className="prescription-body-e-prescription-choose-title">
                                    <span>انتخاب نوع بیمه</span>
                                </div>
                                <div className="prescription-body-e-prescription-choose-item">
                                    <span>بیمه تامین اجتماعی</span>
                                    <input type="radio" name="bim" id=""
                                           onClick={e => set_insuranceType("tamin")}
                                           checked={insuranceType === "tamin"}/>
                                </div>

                                <div className="prescription-body-e-prescription-choose-item">
                                    <span>بیمه سلامت / خدمات درمانی</span>
                                    <input type="radio" name="bim" id=""
                                           onClick={e => set_insuranceType("salamat")}
                                           checked={insuranceType === "salamat"}/>
                                </div>
                            </div>

                        </div>
                        : null}

                    {activeTab === "list" ?
                        <div className="prescription-body-pList">

                            {prescriptions.map(p => {
                                return (
                                    <OrderCard
                                        p={p}
                                        generateDescFromPrescription={generateDescFromPrescription}
                                        del={deletePrescriptionFromOrder}
                                    />
                                )
                            })}

                        </div>
                        : null}
                </div>


                {activeTab === "track" ?
                    <div className="prescription-body-pList">

                        {meds.map(p => {
                            return (
                                <MedCard
                                    p={p}
                                    generateDescFromPrescription={generateDescFromPrescription}
                                    del={deletePrescriptionFromOrder}
                                    mId={merchant?.uid}
                                />
                            )
                        })}

                        <Pagination defaultCurrent={1} onChange={handleOnchangePage}  total={total} />
                    </div>
                    : null}



                {activeTab !== "default" && activeTab !== "list" ? <div className="prescription-add-to-order">
                    <span onClick={() => {
                        addToCurrentPrescription()
                    }}>افزودن به سفارش</span>
                </div> : null}

                {activeTab === "list" && prescriptions.length > 0? <div className="prescription-add-to-order" onClick={finalizeAddOrder}>
                    <span>تایید نهایی و ثبت سفارش</span>
                </div> : null}


            </div>

            {/*<Collapse*/}
            {/*    bordered={false}*/}
            {/*    defaultActiveKey={['2']} onChange={onChange}>*/}
            {/*    <Panel header="سفارش نسخه" key="1">*/}


            {/*        */}


            {/*    </Panel>*/}
            {/*</Collapse>*/}

        </div>
    )
}

export default PrescriptionSec
